import { IconButton, Tooltip } from '@radix-ui/themes'
import { useNavigation } from '@remix-run/react'
import cn from 'clsx'
import * as React from 'react'
import { SubmissionButton } from '~/components/common/submission-button.tsx'
import { type GetProductOptionValue } from '~/models/ecommerce-providers/sylius/shop/fetch/product-option-value/get-product-option-value'
import { type GetProductVariant } from '~/models/ecommerce-providers/sylius/shop/fetch/product-variant/get-product-variant'
import { type ProductOptionValueNormalized } from '~/models/ecommerce-providers/sylius/shop/interface/product-option-value'

type ProductOptionValueProps = {
	searchParams: URLSearchParams
	code: string
	selectedVariant: GetProductVariant
	value: GetProductOptionValue
	name: string
}

const ProductOptionValue: React.FC<ProductOptionValueProps> = ({
	searchParams,
	code,
	selectedVariant,
	value,
	name,
}) => {
	const active = React.useMemo(
		() =>
			Boolean(
				(!searchParams.has(code!) &&
					(selectedVariant.optionValues as ProductOptionValueNormalized[]).find(
						({ code }) => code === value.code,
					)) ||
					searchParams.get(code!) === value.value,
			),
		[value, selectedVariant, searchParams, code],
	)

	const navigation = useNavigation()

	return (
		<li
			key={value.code}
			className={cn('rounded-full', 'transition-all duration-500 ease-in-out', {
				'shadow shadow-accent-7': active,
			})}
		>
			<Tooltip content={name!}>
				<IconButton
					variant={active ? 'surface' : 'soft'}
					size="3"
					radius="full"
					aria-selected={active}
					name={code}
					value={value.value!}
					type="submit"
					className="transition-all duration-500 ease-in-out"
				>
					<SubmissionButton
						navigation={navigation}
						same={navigation.formData?.get('size') == value.value}
					>
						{value.value}
					</SubmissionButton>
				</IconButton>
			</Tooltip>
		</li>
	)
}

/* -----------------------------------------------------------------------------------------------*/

export { ProductOptionValue }
